import React, { Component } from 'react';
import { connect } from 'react-redux';

import { openCustomerModal } from '../modules/active_modal';

class IconCustomerState extends Component {
  render() {
    let {dispatch} = this.props;
    let iconAccount = (
        <svg version="1.1" id="Layer_1" x="0px" y="0px" width="33px" height="33px" viewBox="0 0 864 864" enable-background="new 0 0 864 864" >
        <g>
           <path fill="#A2B4B8" d="M794.5,712.542c0,27.801,0,55.629,0,85.306c-241.025,0-482.078,0-723.104,0c0-27.828,0-55.629,0-85.306
              c1.848-3.696,1.848-7.421,3.696-11.115c5.543-33.372,22.229-57.478,51.906-70.468c16.687-7.419,33.373-11.115,50.059-14.811
              C216,605.006,254.944,595.739,292.012,580.9c42.667-18.562,51.934-50.059,29.676-92.697c-9.267-18.562-20.381-37.096-27.801-57.506
              c-29.676-64.897-50.086-133.49-37.096-207.653c11.142-70.468,50.058-118.679,118.678-139.061
              c11.115-3.724,24.105-5.571,35.22-9.295c14.839,0,29.677,0,44.515,0c1.849,0,5.571,1.875,7.42,1.875
              c77.887,11.115,129.793,59.326,144.632,137.213c11.115,57.478,1.849,111.26-16.687,165.014
              c-12.99,37.067-29.676,74.163-46.363,109.412c-20.409,42.639-12.99,72.287,31.525,94.545c18.534,9.267,38.915,14.838,57.449,20.41
              c31.525,9.267,63.05,16.686,94.574,25.953c33.372,11.114,55.629,33.371,63.05,70.468
              C792.652,703.274,792.652,708.846,794.5,712.542z"/>
        </g>
        </svg>
      )
    return (
      <span className="icon-holder account unselectable" onClick={() => dispatch( openCustomerModal() )}>
        {iconAccount}
        <div className="menu-nav-text">Account</div>
      </span>
    );
  }
};

export default connect()(IconCustomerState);


// WEBPACK FOOTER //
// ./src/components/IconCustomerState.jsx